<template>
  <el-table-column :label="label" :prop="prop" class-name="invoice_address" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '請求先宛名'
    },
    prop: {
      type: String,
      default: 'invoice_address'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.invoice_address {
      width: 15em;
    }
  }
}
</style>
